<template>
  <div id="index">
    <bread-crumbs :links="breadsCrumbs"></bread-crumbs>
    <v-layout row wrap>
      <v-flex md4 v-if="!isSP" style="padding-right:16px">
          <karalog-info></karalog-info>
      </v-flex>
      <v-flex xs12 md8>
        <v-card style="min-height:800px;border-radius:16px;">
          <v-container>
          <div v-show="isLoading" style="text-align:center;height:400x;padding-top:150px;">
            <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
          </div>
          <div v-if="!isLoading">
            <!-- レビューの本文 -->
            <review-view
              v-if="select.post"
              :post="select.post" :imageurls="select.imageurls" :onClickPosition="select.onClickPosition"
              @onCommentIcon='onCommentIcon'
              @onMessage='onMessage'
            ></review-view>
            <!-- ／レビューの本文 -->

            <!-- 辛さ比較 -->
            <karasa-rank-card
              v-if="rank"
              :rank=rank :focusPosition=focusPosition
            >
            </karasa-rank-card>
            <!-- ／辛さ比較 -->

            <!-- SNSシェア -->
            <div style="background:#eee;border-radius:10px;padding:16px;margin-bottom:16px;">
              <h2 style="margin-bottom:16px;text-align:left;">カラログをシェアしよう！</h2>
              <p style="margin:0">
                <sns-buttons></sns-buttons>
              </p>
            </div>
            <!-- ／SNSシェア -->

            <!-- コメント投稿 -->
            <v-flex xs12 id="commentForm">
              <review-comment-form
                @onReviewCommentAdd="refreshComment"
                @onMessage='onMessage'
                :postId="select.post.id" :userName="select.post.user.displayName"
              ></review-comment-form>
            </v-flex>
            <!-- ／コメント投稿 -->
            <!-- コメントの一覧 -->
            <v-flex xs12 style="margin-top:16px;">
              <review-comment-card 
                v-for="(comment, id) in comments"
                :c=comment :key=id
              ></review-comment-card>
            </v-flex>
            <!-- ／コメントの一覧 -->
            <!-- ユーザー投稿の一覧 -->
            <v-flex v-if="select.post" xs12 style="margin-top:16px">
              <user-review-card
                :user="select.post.user"
                :without="select.id"
              ></user-review-card>
            </v-flex>
            <!-- /ユーザー投稿の一覧 -->
          </div>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { db } from '@/main'
import BreadCrumbs from '@/components/common/BreadCrumbs.vue'
import SnsButtons from '@/components/common/SnsButtons.vue'
import ReviewView from '@/components/card/ReviewView.vue'
import ReviewCommentForm from '@/components/form/ReviewCommentForm'
import ReviewCommentCard from '@/components/card/ReviewCommentCard'
import KaralogInfo from '@/components/card/KaralogInfo.vue'
import UserReviewCard from '@/components/card/UserReviewCard.vue'
import KarasaRankCard from '@/components/card/KarasaRankCard.vue'

import getImageUrl from '@/assets/js/getImageUrl.js'
export default {
  name: 'ReviewDetail',
  data () {
    return {
      isLoading: false,
      select: {
        id: undefined,
        post: undefined,
        imageurls: []
      },
      breadsCrumbs: [],
      breadsCrumbsForSearch: [{name: 'home', meta: {pageName: 'トップ'}}, {name: 'searchReview', meta: {pageName: 'みんなのカラログ'}}],
      comments: [],
      rank: undefined,
      focusPosition: undefined
    }
  },
  computed: {
    isSP () {
      if (this.displaySize==='xs' || this.displaySize==='sm') return true
      return false
    },
    displaySize () {
      return this.$vuetify.breakpoint.name
    },
    headerTitle () {
      let title = ''
      if (this.select.post) {
        if (this.select.post.user) {
          title = title +  this.select.post.user.displayName + 'さんのカラログ'
        }
        let mode = this.select.post.mode
        if (mode === 'food' || mode === 'free') {
          title = title + ' ' + this.select.post.food.name
        } else if (mode === 'shop') {
          title = title + ' ' + this.select.post.shop.name
        }
      }
      return title
    },
    foodId () {
      if (this.select.post) {
        let mode = this.select.post.mode
        if (mode === 'food' || mode === 'free') {
          return this.select.post.food.id
        }
      }
      return undefined
    },
    headerDescription () {
      if (this.select.post === undefined) return ''
      let text = this.select.post.content
      if (text.length >= 300) {
        text = text.substr(0, 300)
      }
      return text
    }
  },
  filters: {
  },
  watch: {
    '$route' () {
      this.init()
    }
  },
  created () {
    this.init()
  },
  mounted () {
  },
  methods: {
    async init () {
      window.scrollTo(0, 0)
      this.select.id = this.$route.params.id
      this.select.post = this.$store.getters.getPostById(this.select.id)
      if (this.select.post) {
        this.select.imageurls = this.select.post.imageurls
      } else {
        await this.getDetail()
      }
      this.$emit('updateHead')
      this.detailBread()
      this.getRank(this.select.post.user.uid)
      await this.refreshComment()
      this.scroll()
    },
    async refreshComment () {
      let response = await db.collection('post').doc(this.select.id).collection('comment').orderBy('timestamp', 'desc').get()
      this.comments = []
      response.forEach((doc) => {
        let comment = doc.data()
        comment.id = doc.id
        this.comments.push(comment)
      })
    },
    async getRank (uid) {
      let doc = await db.collection('rank').doc(uid).get()
      let rank = doc.data()
      rank.id = doc.id
      // 今回のレビューIDが含まれるかチェック
      let flag = false
      let focusPosition = 0
      for (let i = 0; i < rank.foods.length; i++) {
        if (rank.foods[i].postId) {
          if (rank.foods[i].postId === this.select.id) {
            flag = true
            focusPosition = i
            break
          }
        }
      }
      if (flag) {
        this.rank = rank
        this.focusPosition = focusPosition
      }
    },
    detailBread () {
      let breads = this.breadsCrumbsForSearch.concat()
      breads.push({
        name: 'searchReviewDetail',
        params: {id: this.select.id},
        meta: {pageName: this.headerTitle}
      })
      this.breadsCrumbs = breads
    },
    async getDetail () {
      this.isLoading = true
      let response = await db.collection('post').doc(this.select.id).get()
      this.select.post = response.data()
      this.select.post.id = this.select.id
      this.getImageUrl()
      this.isLoading = false
    },
    getImageUrl () {
      if (this.select.post.images === undefined) return
      this.select.imageurls = []
      this.select.post.images.forEach(async path => {
        let url = getImageUrl.get('post', this.select.id, path)
        this.select.imageurls.push(url)
        // this.select.imageurls.sort(function (a, b) {
        //   if( a < b ) return -1
        //   if( a > b ) return 1
        //   return 0
        // })
      })
    },
    scroll () {
      if (this.$route.query.position) {
        let p = this.$route.query.position
        if (p === 'comment') {
            let target = document.getElementById('commentForm')
            this.$SmoothScroll(target, 500, undefined, undefined, 'y')
        }
      }
    },
    onCommentIcon () {
      let target = document.getElementById('commentForm')
      this.$SmoothScroll(target, 500, undefined, undefined, 'y')
    },
    onMessage (obj) {
      this.$emit('onMessage', obj)
    },

  },
  components: {
    BreadCrumbs,
    SnsButtons,
    ReviewView,
    ReviewCommentForm,
    ReviewCommentCard,
    KaralogInfo,
    UserReviewCard,
    KarasaRankCard
  },
  head: {
    title () {
      if (this.headerTitle !== '') {
        return {
          inner: this.headerTitle,
          separator: ' ',
          complement: 'カライイネ 激辛・旨辛グルメ特化のSNS！'
        }
      }
    },
    meta () {
      if (this.headerTitle !== '') {
        return [
          {name: 'description', content: this.headerDescription}
        ]
      }
    },
    link () {
      if (this.foodId) {
        return [
          {rel: 'canonical', href: `https://karaiine.jp/food/${this.foodId}`}
        ]
      }
    }
  }
}
</script>

<style scoped>
  #index{
    min-height:90vh;
    text-align:center;
  }
</style>